'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('bhired_competency', {
      url: '/bhired_competency',
      template: '<bcompetencytab></bcompetencytab>'
    });
}
